import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ordinario-view',
  templateUrl: './form-ordinario-view.component.html',
  styleUrls: ['./form-ordinario-view.component.css']
})
export class FormOrdinarioViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
